import { Text, Flex } from '@radix-ui/themes'
import { GoogleLogin } from '@react-oauth/google'
import { useAuthentication } from '../contexts/AuthenticationContext.tsx'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export const LoginPage = () => {
  const { user, loginWithCredential } = useAuthentication()
  const navigate = useNavigate()

  useEffect(() => {
    if (user) {
      navigate('/')
    }
  }, [user, navigate])

  return (
    <Flex direction="column" gap="4" align="center">
      <Text size="5" weight="bold">
        로그인
      </Text>
      <Text color="gray">AB180 Google 계정으로 로그인해주세요</Text>
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          if (credentialResponse.credential) {
            loginWithCredential(credentialResponse.credential)
          }
        }}
        onError={() => {
          console.log('Login Failed')
        }}
        useOneTap
        auto_select={false}
      />
    </Flex>
  )
}